import { useResizeListener } from '../../../hooks/windowEvents/useResizeListener';

type StringOrUndefined = string | undefined;

interface IImageCollection {
    imageUrls: StringOrUndefined[];
    maxImages?: number;
}

const IMAGE_TRANSLATION_PERCENTAGE = 60;
const IMAGE_WIDTH = 40;
const MOBILE_IMAGE_WIDTH = 24;

const calulateTranslateX = (index: number) => {
    return `translateX(${index * IMAGE_TRANSLATION_PERCENTAGE}%)`;
};

const calcluateWidth = (numberOfImages: number, isMobile: boolean) => {
    const imgWidth = isMobile ? MOBILE_IMAGE_WIDTH : IMAGE_WIDTH;
    return imgWidth * ((numberOfImages - 1) * (IMAGE_TRANSLATION_PERCENTAGE / 100) + 1);
};

export const ImageCollection = ({ imageUrls, maxImages }: IImageCollection) => {
    const { isXSmall, isSmall, isMedium } = useResizeListener();
    const isMobile = isXSmall || isSmall || isMedium;

    const visibleImages = maxImages ? imageUrls.slice(0, maxImages) : imageUrls;

    return (
        <div className="image-collection" style={{ width: calcluateWidth(visibleImages.length, isMobile) }}>
            {visibleImages.map((url, i) => (
                // eslint-disable-next-line jsx-a11y/alt-text
                <img
                    alt="Profile"
                    style={{ transform: calulateTranslateX(i) }}
                    className="image-collection__img"
                    key={url ?? `${i}/svg/person.svg`}
                    src={url ?? '/svg/person.svg'}
                />
            ))}
        </div>
    );
};
